var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 12 12)",
    fill: "#F69606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.0001H7C6.73488 17.9998 6.4807 17.8944 6.29323 17.7069C6.10576 17.5194 6.0003 17.2652 6 17.0001V7.00012C6.0003 6.735 6.10576 6.48082 6.29323 6.29335C6.4807 6.10588 6.73488 6.00042 7 6.00012H17C17.2651 6.00042 17.5193 6.10588 17.7068 6.29335C17.8942 6.48082 17.9997 6.735 18 7.00012V17.0001C17.9997 17.2652 17.8942 17.5194 17.7068 17.7069C17.5193 17.8944 17.2651 17.9998 17 18.0001ZM9 7.00012H7V17.0001H9V7.00012ZM15 10.5001H11C10.8674 10.5001 10.7402 10.5528 10.6464 10.6466C10.5527 10.7403 10.5 10.8675 10.5 11.0001C10.5 11.1327 10.5527 11.2599 10.6464 11.3537C10.7402 11.4474 10.8674 11.5001 11 11.5001H15C15.1326 11.5001 15.2598 11.4474 15.3536 11.3537C15.4473 11.2599 15.5 11.1327 15.5 11.0001C15.5 10.8675 15.4473 10.7403 15.3536 10.6466C15.2598 10.5528 15.1326 10.5001 15 10.5001ZM15 12.5001H11C10.8674 12.5001 10.7402 12.5528 10.6464 12.6466C10.5527 12.7403 10.5 12.8675 10.5 13.0001C10.5 13.1327 10.5527 13.2599 10.6464 13.3537C10.7402 13.4474 10.8674 13.5001 11 13.5001H15C15.1326 13.5001 15.2598 13.4474 15.3536 13.3537C15.4473 13.2599 15.5 13.1327 15.5 13.0001C15.5 12.8675 15.4473 12.7403 15.3536 12.6466C15.2598 12.5528 15.1326 12.5001 15 12.5001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.342f3ca7.svg";
export { ForwardRef as ReactComponent };